<template>
  <form class="user-editor">
    <h4>ข้อมูลผู้ใช้</h4>
    <hr />
    <div class="row">
      <div class="col-6">
        <label class="label">อีเมล</label>
        <el-input v-model="$v.value.email.$model" type="email"></el-input>
        <span v-if="!hasInput('email')" class="help-text text-danger"
          >กรุณากรอกข้อมูล</span
        >
      </div>
      <div class="col-6">
        <label class="label">รหัสผ่าน</label>
        <el-input
          v-model="$v.value.password.$model"
          minlength="6"
          maxlength="32"
          type="password"
        ></el-input>
        <span v-if="!hasInput('password')" class="help-text text-danger"
          >กรุณากรอกข้อมูล</span
        >
      </div>
    </div>
    <h4>ข้อมูลส่วนตัว</h4>
    <hr />
    <div class="row">
      <div class="col-6 mb-3">
        <label class="label">ชื่อจริง</label>
        <el-input v-model="$v.value.firstName.$model"></el-input>
        <span v-if="!hasInput('firstName')" class="help-text text-danger"
          >กรุณากรอกข้อมูล</span
        >
      </div>
      <div class="col-6 mb-3">
        <label class="label">นามสกุล</label>
        <el-input v-model="$v.value.lastName.$model"></el-input>
        <span v-if="!hasInput('lastName')" class="help-text text-danger"
          >กรุณากรอกข้อมูล</span
        >
      </div>
      <div class="col-6">
        <label class="label">เพศ</label>
        <el-select v-model="$v.value.gender.$model" class="select">
          <el-option label="ชาย" value="m"></el-option>
          <el-option label="หญิง" value="f"></el-option>
        </el-select>
        <span v-if="!hasInput('gender')" class="help-text text-danger"
          >กรุณากรอกข้อมูล</span
        >
      </div>
      <div class="col-6">
        <label class="label">วันเกิด</label>
        <el-datepicker
          :value="birthDate"
          class="select"
          @input="handleChangeBirthDate"
        ></el-datepicker>
        <span v-if="!hasInput('birthDate')" class="help-text text-danger"
          >กรุณาเลือกวันเกิด</span
        >
      </div>
    </div>
  </form>
</template>

<script>
import { Input, Select, Option, DatePicker } from "element-ui"
import { validationMixin } from "vuelidate"
import { required, email } from "vuelidate/lib/validators"
import { DateTime } from "luxon"
import { isNil } from "ramda"

export default {
  components: {
    "el-input": Input,
    "el-select": Select,
    "el-option": Option,
    "el-datepicker": DatePicker,
  },
  mixins: [validationMixin],
  props: {
    value: {
      type: null,
      default: undefined,
    },
  },
  computed: {
    birthDate() {
      if (!this.value || !this.value.birthDate) {
        return null
      }

      return this.value.birthDate.toJSDate()
    },
  },
  validations: {
    value: {
      email: {
        required,
        email,
      },
      password: {
        required,
      },
      firstName: {
        required,
      },
      lastName: {
        required,
      },
      gender: {
        required,
      },
      birthDate: {
        required,
      },
    },
  },
  methods: {
    handleChangeBirthDate(dateTime) {
      if (!isNil(dateTime)) {
        const utc = DateTime.fromJSDate(dateTime).toUTC()

        this.$emit("input", { ...this.value, birthDate: utc })
      } else {
        this.$emit("input", { ...this.value, birthDate: null })
      }
    },
    hasInput(inputName) {
      switch (inputName) {
        case "email":
          return !this.$v.value.email.$dirty || this.$v.value.email.required
        case "password":
          return (
            !this.$v.value.password.$dirty || this.$v.value.password.required
          )
        case "firstName":
          return (
            !this.$v.value.firstName.$dirty || this.$v.value.firstName.required
          )
        case "lastName":
          return (
            !this.$v.value.lastName.$dirty || this.$v.value.lastName.required
          )
        case "gender":
          return !this.$v.value.gender.$dirty || this.$v.value.gender.required
        case "birthDate":
          return (
            !this.$v.value.birthDate.$dirty || this.$v.value.birthDate.required
          )
        default:
          return true
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.label {
  font-weight: bold;
}

.row {
  margin-bottom: $space;
}

.select {
  display: block;
  width: 100%;
}
</style>
